export default [
  { title: "Home", text: "Home" },
  { title: "Bio", text: "Bio" },
  { title: "Order", text: "Submit a Pizza Order" },
  { title: "Pizza", text: "See all the Pizzas" }
];
